import ar from './ar';
import en from './en';
import fr from './fr';

export const appResources = {
  en: { translation: en },
  fr: { translation: fr },
  ar: { translation: ar },
} as const;

export type AppLanguage = keyof typeof appResources;
